import {ChangeDetectorRef, Component, ElementRef, forwardRef, Input} from "@angular/core";
import {NG_VALUE_ACCESSOR} from "@angular/forms";
import {FUIAbstractPasswordInput} from "../abstract-password-input";

@Component({
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => FUIEditPasswordInputComponent),
            multi: true
        }
    ],
    selector: "fui-edit-password-input",
    styleUrls: ["./edit-password-input.component.scss"],
    templateUrl: "./edit-password-input.component.html"
})
export class FUIEditPasswordInputComponent extends FUIAbstractPasswordInput {
    @Input() allowAutocomplete: boolean;

    constructor(elementRef: ElementRef,
                changeDetectorRef: ChangeDetectorRef) {
        super(elementRef, changeDetectorRef);
    }
}
